import { createColumnHelper } from '@tanstack/react-table';
import { InternalApiEntityGroup } from '../../../api-internal';
import React, { useMemo } from 'react';
import { SalvTooltipWrapper } from '@salvapp/ui-components';
import { FullCalculationLabel } from './helper';

const useSegmentColumns = () => {
  const columnHelper = createColumnHelper<InternalApiEntityGroup>();
  return useMemo(
    () => [
      columnHelper.accessor('name', {
        header: 'Name',
        cell: ({ row: { original } }) => {
          return (
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <span>{original.name}</span>
              <FullCalculationLabel segment={original} />
            </div>
          );
        },
      }),
      columnHelper.accessor('rule', {
        header: 'Preview',
        cell: ({ getValue }) => (
          <SalvTooltipWrapper tooltip={getValue()} placement='bottom left'>
            <div className='code-s rule' style={{ width: '50ch' }}>
              {getValue()}
            </div>
          </SalvTooltipWrapper>
        ),
      }),
    ],
    []
  );
};

export default useSegmentColumns;
